import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { FormularioComponent } from './formulario/formulario.component';
import { ConstanciaComponent } from "./constancia/lista.component";
import { EventoRegistroComponent } from "./evento-registro/evento-registro.component";
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'eventos/evento',
    children: [
      { path: 'lista', component: ListaComponent},
      { path: 'nuevo', component: FormularioComponent },
      { path: 'constancia', component: ConstanciaComponent },
      { path: 'evento-registro', component: EventoRegistroComponent },
      { path: 'editar/:id', component: FormularioComponent},
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class EventoRoutingModule { }

